import React, { useState } from 'react';
import { Table as AntTable, Button, Modal, Typography, Image, Row, Col, Badge } from 'antd';
import { Descriptions, Divider } from 'antd';
import { SearchOutlined, EditOutlined, UnorderedListOutlined, RightOutlined, DownOutlined, CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { genNumberTable } from '../../../../function/genNumberTable';
import dayjs from 'dayjs';
const { Title, Text } = Typography;
const headerStyle = {
  color: "white",
  fontWeight: "bold",
  backgroundColor: "#4a4a4a",
  textAlign: 'center',
};


const TableInput = ({ data = [], loading = false, refetch }) => {
  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'number',
      key: 'number',
      align: 'center',
      width: 100,
      onHeaderCell: () => ({ style: headerStyle }),
      // onCell: () => ({ style: { backgroundColor: '#4a4a4a' } }),
      //render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
    },
    {
      title: 'Admin',
      dataIndex: 'create_by_name',
      key: 'create_by_name',
      align: 'center',
      width: 100,
      onHeaderCell: () => ({ style: headerStyle }),
      // render: (text, record) => (
      //   <span style={{ color: '#4caf50', fontWeight: 'bold' }}>
      //     {record.case3Display || '-'}
      //   </span>
      // ),
    },
    {
      title: 'All',
      dataIndex: 'total',
      key: 'total',
      align: 'center',
      width: 80,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
    },
    {
      title: 'Dep',
      dataIndex: 'depTotal',
      key: 'depTotal',
      align: 'center',
      width: 90,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
    },

    {
      title: 'Withdraw',
      dataIndex: 'witTotal',
      key: 'witTotal',
      align: 'center',
      width: 100,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
    },
    {
      title: 'ETC.',
      dataIndex: 'etcTotal',
      key: 'etcTotal',
      align: 'center',
      width: 90,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
    },
  ];

  return (
    // <div style={{ padding: '20px', background: '#fff' }}>
    <div className='overflow-x-auto'>
      <AntTable
        loading={loading}
        dataSource={genNumberTable(data)}
        columns={columns}
        //pagination={{ pageSize: 10 }}
        rowKey="finish_by"
        scroll={{ x: 'max-content' }}
        bordered
        pagination={{
          position: ['topRight'],     // 👈 เลือกตำแหน่งได้
          //pageSize: 20,
        }}
        pageSize={10}
        pageSizeOptions={[10, 20, 50, 100]}
        showSizeChanger={true}
        showQuickJumper={true}
      //showTotal={(total, range) => `รวม ${total} รายการ`}
      // onChange={(page, pageSize) => {
      //   console.log(page, pageSize);
      // }}
      />
      <style>{`
        .table-row-light {
          background-color: #f5f5f5;
        }
        .ant-table-tbody > tr:hover > td {
          background-color: #e8f4f8 !important;
        }
        .ant-table-thead > tr > th.ant-table-row-expand-icon-cell {
          background-color: #4a4a4a !important;
          color: white !important;
        }
      `}</style>
    </div>
    // </div>
  );
};

export default TableInput;

